export const FONT = `"Monocraft", monospace`;

export async function loadFont() {
  try {
    await document.fonts.load(`16px ${FONT}`);
  } catch {}
}
